export default "__VITE_ASSET__CElrYFEq__"